import NoPerm from './no-perm.vue'
export default NoPerm
